/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SalesList from "./Sales/SalesList";
import PurchaseList from "./Purchases/PurchaseList";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import ByPurchaseList from "./ByPurchase";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const FundsCardDetail = () => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [activeTab, setActiveTab] = useState(0);
  const [targetPermission, setTargetPermission] = useState(null);
  const [scrapingPermission, setScrapingPermission] = useState(null);
  const [cardHistoryPermission, setCardHistoryPermission] = useState(false);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FUND_CARD_HISTORY');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "FUND_CARD_HISTORY");
      }

      setCardHistoryPermission(permissions.find(p => p.code === 'FUND_CARD_HISTORY'));
      const scrapingPermission = permissions.find(p => p.code === 'FINANCE_SCRAPING');
      setScrapingPermission(scrapingPermission);
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push(`/funds/card-detail?tab=${value}`);
  };

  const tabList = [
    {
      label: "매출",
      action: _setActiveTab,
      value: 'sales'
    },
    {
      label: "매입",
      action: _setActiveTab,
      value: 'purchases'
    },
    {
      label: "매입 건별",
      action: _setActiveTab,
      value: 'by-purchases'
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);


  return (
    !isEmpty(targetPermission) && (
      <div className="page-content">
        {activeTab === 'sales' && <SalesList permission={targetPermission} activeTab={activeTab} tabList={tabList} />}
        {activeTab === 'purchases' && <PurchaseList permission={targetPermission} activeTab={activeTab} tabList={tabList} />}
        {activeTab === 'by-purchases' && (
          <ByPurchaseList
            activeTab={activeTab}
            tabList={tabList}
            scrapingPermission={scrapingPermission}
            cardHistoryPermission={cardHistoryPermission}
          />
        )}
      </div>
    )
  );
};

export default FundsCardDetail;
